/**
 * Tabber
 */
define('Tabber',['jquery', 'UI'], function($, UI) {
    "use strict";

    return function(options) {
        var defaults = {
                elContainer: '.tabber',
                elTabsClass: 'tabs',
                elTabsContentClass: 'tabs-content'
            },
            o,
            _bindEvents = function() {
                UI.$b.on('click', o.elContainer+' .'+o.elTabsClass+' > li', function () {
                    var $el = $(this),
                        $elContentWrapper = $el.parent().siblings('.'+o.elTabsContentClass),
                        index = $el.index(); // n-1
                    $el.addClass('active').siblings().removeClass('active');
                    $elContentWrapper.children('.tab-content:eq('+index+')').addClass('active').siblings().removeClass('active');
                });
                return false;
            },
            init = function(options) {
                o = $.extend(defaults, options);
                _bindEvents();
            };
        init(options);
    };
});
